//
import Model from '@/models/Model'

/**
 * This class describes sl customer branch offices.
 * @class SlCustomerBranchOffices (name)
 */
export default class SlCustomerBranchOffices extends Model {

  /**
   * SlCustomerBranchOffices resource endpoint.
   * @return {string}
   */
  resource() {
    return 'sl_customer_branch_offices'
  }
}
